var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isCurrentStore
    ? _c(
        "div",
        { staticClass: "selected-store" },
        [
          _c(
            "q-tabs",
            {
              attrs: { align: "left" },
              model: {
                value: _vm.currentTab,
                callback: function($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab"
              }
            },
            _vm._l(_vm.tabs, function(tab, index) {
              return _c("q-tab", {
                key: index,
                attrs: { name: tab.name, label: tab.label }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content-block" },
            [
              _c(_vm.currentTab, {
                tag: "component",
                staticClass: "component",
                on: {
                  "create-zone": function($event) {
                    return _vm.$emit("create-zone")
                  },
                  "edit-zone": function($event) {
                    return _vm.$emit("edit-zone", $event)
                  },
                  "remove-zone": function($event) {
                    return _vm.$emit("remove-zone", $event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }